import { useState } from 'react'
import PropTypes from 'prop-types'

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  DropdownMenuItem,
} from '@/components/ui/dropdown-menu'
import { Icons } from '@/theme/Images'
import { useAuth } from '../../contexts/auth.context'

const ProfileDropdownMenu = () => {
  const [isOpen, setIsOpen] = useState(false)
  const { user, logout } = useAuth()

  return (
    <DropdownMenu onOpenChange={d => setIsOpen(d)} modal={true} open={isOpen} className="w-6">
      <DropdownMenuTrigger asChild>
        <img src={Icons.userIcon} alt="user image" />
      </DropdownMenuTrigger>
      <DropdownMenuContent className="bg-white text-black border-dGray-300 border-1 w-[60vw] md:w-[18vw] rounded-lg mt-6 absolute top-[-10px] right-[-5vw] md:right-[-1.3vw]">
        <div className="flex flex-row h-[50px] px-4 py-3 items-center">
          <div className="hidden md:flex justify-center items-center rounded-full bg-dGray-100 border-dGray-300 border-1 h-10 w-10 mr-2">
            <img src={Icons.userIcon} alt="icon" />
          </div>
          <div className="flex flex-col justify-center items-start w-auto">
            <p className="font-semibold text-sm text-[--gray-700]">{user?.name}</p>
            <p className="font-normal text-sm text-dGray-600">{user?.email}</p>
          </div>
        </div>
        <DropdownMenuSeparator className="bg-dGray-200 " />
        <DropdownMenuItem className={'text-dGray-300 text-md py-3 px-4 cursor-pointer'} onClick={() => logout()}>
          <div className="flex flex-row justify-start items-center">
            <img src={Icons.logoutIcon} alt="icon" height={16} width={16} />
            <span className="text-dGray-700 font-medium text-sm ml-2">Log out</span>
          </div>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

ProfileDropdownMenu.propTypes = {
  data: PropTypes.object,
}

export default ProfileDropdownMenu
